var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.mode === "default"
    ? _c("div", { staticClass: "bic-footer-img" }, [
        _c("img", {
          attrs: { src: "_resources/themes/bic/images/hp-footer.png" },
        }),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }